import { render, staticRenderFns } from "./RightNav.vue?vue&type=template&id=74d6cee6&scoped=true&"
import script from "./RightNav.vue?vue&type=script&lang=js&"
export * from "./RightNav.vue?vue&type=script&lang=js&"
import style0 from "./RightNav.vue?vue&type=style&index=0&id=74d6cee6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d6cee6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74d6cee6')) {
      api.createRecord('74d6cee6', component.options)
    } else {
      api.reload('74d6cee6', component.options)
    }
    module.hot.accept("./RightNav.vue?vue&type=template&id=74d6cee6&scoped=true&", function () {
      api.rerender('74d6cee6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nav/RightNav.vue"
export default component.exports